// extracted by mini-css-extract-plugin
export var navbarSubLink = "D_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "D_tP d_f0 d_dB";
export var subPageLink = "D_gf d_gf";
export var burger = "D_vx";
export var sublinkSize = "D_vy";
export var linkSize = "D_vz";
export var Link = "D_rM q_rM q_qZ q_rj";